import React from 'react';
import styled from "styled-components/macro";
import { mixins } from './styles';
import moment from 'moment';

const formatTimestamp = (timestamp) => moment(timestamp).local().format("YYYY-MM-DD HH:mm:ss");

const NoteWrapper = styled.div`
  ${mixins.flexColumn}

  gap: 8px;
  padding: 12px 14px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  max-width: 650px;
`;

const NoteMetaWrapper = styled.div`
  font-size: small;

  & em {
    font-weight: light;
    color: #777;
  }
`;

const HighlightedLink = styled.a`
  color: #1d4ed8;
  font-weight: 600;
  text-decoration: underline;
  background: rgba(59, 130, 246, 0.12);
  padding: 0 2px;
  border-radius: 4px;
`;

const renderNoteContent = (text = "") => {
  if (!text) {
    return null;
  }

  const regex = /https?:\/\/[^\s]+|www\.[^\s]+/gi;
  const segments = [];
  let lastIndex = 0;
  let match;

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      segments.push(text.slice(lastIndex, match.index));
    }

    const urlText = match[0];
    const href = urlText.startsWith("http") ? urlText : `https://${urlText}`;
    segments.push(
      <HighlightedLink
        key={`link-${match.index}`}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
      >
        {urlText}
      </HighlightedLink>
    );

    lastIndex = match.index + urlText.length;
  }

  if (lastIndex < text.length) {
    segments.push(text.slice(lastIndex));
  }

  return segments.length ? segments : text;
};

const NoteMeta = ({ note, author }) => {
  const authorLabel = author?.email || author?.displayName || "Unknown user";
  return (
    <NoteMetaWrapper>
      <em>{authorLabel}</em> on <em>{formatTimestamp(note.createdAt)}</em> added:
    </NoteMetaWrapper>
  );
};

const UserNote = ({ note, author }) => {
  return (
    <NoteWrapper>
      <NoteMeta note={note} author={author} />
      <p>
        {renderNoteContent(note.content)}
      </p>
    </NoteWrapper>
  );
};

export default UserNote;
